var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('Slideshow',{attrs:{"on-end-exit":_vm.onEndExit,"mouse-navigation":false,"back-by-slide":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }